module.exports = __webpack_public_path__ + "img/img-ad01bb37.80c43209.png";